import { createContext, useContext } from "@wordpress/element";

export const AppContext = createContext({
    blockConfig: {},
});

export const AppWrapper = ({ children, blockConfig = {} }) => {
    return (
        <AppContext.Provider value={{ blockConfig }}>
            {children}
        </AppContext.Provider>
    );
};

/**
 * Block toggles from ACF (data-wl-config), merged in frontend.js with defaults.
 */
export const useBlockConfig = () => {
    const ctx = useContext(AppContext);
    return ctx && ctx.blockConfig ? ctx.blockConfig : {};
};
